import { AddTicketRedemptionCardErrorCodeV1, AddTicketRedemptionCardErrorV1 } from '@vista-digital/ocapi-client';
import { OrderTicketRedemptionCardRequestType } from '@vista-digital/ocapi-types/v1';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { CommonErrorCodes } from '../../../../types/errors/common-error-codes';
import { logger } from '../../../../utils/logger';
import { nonEmptyStringValidator } from '../../../../utils/validators/string';
import { thirdPartyMemberCardCredentialsValidator } from '../../../../utils/validators/third-party-member-card-credentials';
import { OrderDomainError, OrderDomainSpecificErrorCode } from '../../errors/order-domain-error';
import { getOrder } from '../../selectors/order/get-order';
import { assertIsStandardOrder } from '../../utils/order-type-utils';
import { attemptToAddOrderTicketForRedemptionCard } from '../tickets/attempt-to-add-order-ticket-for-redemption-card';
import { registerOrderAction } from '../utils/register-order-action';
import { storeTicketRedemptionCard } from './utils/store-ticket-redemption-card';
/**
 * Adds a third party member card to the order
 */
export const addThirdPartyMemberCardForOrderShowtime = async (showtimeId, credentials, attemptToAutomaticallyAddTicket = true) => {
    const order = getOrder();
    assertIsStandardOrder(order, 'Cannot add third party member card');
    if (!nonEmptyStringValidator(showtimeId, logger.error, 'showtimeId')) {
        throw new Error('Cannot add third party member card. Provided showtimeId is invalid.');
    }
    if (!thirdPartyMemberCardCredentialsValidator(credentials, logger.error, 'credentials')) {
        throw new Error('Cannot add third party member card. Provided credentials are invalid.');
    }
    const deregisterAction = registerOrderAction('add-third-party-member-card-for-order-showtime');
    let response;
    try {
        response = await ocapiClient.instance.v1.orders.ticketRedemptionCards.add(order.id, {
            type: OrderTicketRedemptionCardRequestType.ThirdPartyMemberCard,
            showtimeId,
            credentials
        });
    }
    catch (error) {
        if (error instanceof AddTicketRedemptionCardErrorV1) {
            const errorCode = convertApiToDomainErrorCode(error.errorCode);
            throw new OrderDomainError(errorCode, error.message);
        }
        throw error;
    }
    finally {
        deregisterAction();
    }
    storeTicketRedemptionCard(response);
    if (attemptToAutomaticallyAddTicket) {
        attemptToAddOrderTicketForRedemptionCard(showtimeId, response.ticketRedemptionCard);
    }
    return response.ticketRedemptionCard;
};
function convertApiToDomainErrorCode(errorCode) {
    switch (errorCode) {
        case AddTicketRedemptionCardErrorCodeV1.Declined:
            return OrderDomainSpecificErrorCode.ThirdPartyMemberCardDeclined;
        case AddTicketRedemptionCardErrorCodeV1.AlreadyAdded:
            return OrderDomainSpecificErrorCode.ThirdPartyMemberCardAlreadyAdded;
        case AddTicketRedemptionCardErrorCodeV1.ThirdPartyMemberCardHasNoValidTicketForShowtime:
        case AddTicketRedemptionCardErrorCodeV1.ThirdPartyMemberCardHasNoValidTicketForSelectedSeats:
        case AddTicketRedemptionCardErrorCodeV1.ThirdPartyMemberCardHasLoyaltyOnlyTicket:
            return OrderDomainSpecificErrorCode.NoValidTicketsAvailableForThirdPartyMemberCard;
        default:
            return CommonErrorCodes.UnknownError;
    }
}
